import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { WorkOrder, WorkOrderSearchCommand } from '../../models/order/work-order';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private _baseUrl = `${environment.proxyUrls.orderApi}/api/v1/work-order`;

  getById(id: string): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.get<ApiResponse<WorkOrder>>(`${this._baseUrl}/${id}?materialize=true`);
  }

  public search(
    command: WorkOrderSearchCommand,
    pageNumber?: number,
    pageSize?: number,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<WorkOrder>>> {
    let params = new HttpParams();
    if (pageNumber !== undefined) params = params.set('pageNumber', pageNumber.toString());
    if (pageSize !== undefined) params = params.set('pageSize', pageSize.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<WorkOrder>>>(`${this._baseUrl}/search`, command, { params });
  }
}
